import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1001"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.208 1.492c-3.757-.066-6.613 2.536-6.879 5.704-.293 3.494 2.106 4.947 2.427 5.232C2.851 12.399.583 10.28.202 8.295a.104.104 0 0 0-.1-.085.103.103 0 0 0-.103.114c.403 3.526 3.405 6.2 6.789 6.185 3.604-.016 6.518-2.147 6.89-5.645.35-3.295-2.108-5.007-2.424-5.291 2.023.019 4.162 2.15 4.539 4.132.009.048.05.084.099.085a.103.103 0 0 0 .104-.114c-.406-3.521-3.405-6.125-6.788-6.184zm-1.21 8.011a1.502 1.502 0 1 1 0-3.004 1.502 1.502 0 0 1 0 3.004z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }